import { SelectMenuItem } from "./selectmenu";

export class SelectMenuHarnessController {
  public menuItems: SelectMenuItem[];

  constructor() {
    this.menuItems = [
      { itemName: "Service Desk Click 1", itemValue: "click1" },
      { itemName: "Service Desk Click 2", itemValue: "click2" },
      { itemName: "Service Desk Click 3", itemValue: "click2" }
    ];
  }

  public menuItemSelected(menuItem: SelectMenuItem): void {
    console.info(`${menuItem.itemName} was clicked`);
  }

  public menuClicked(name: string): void {
    console.info(name);
  }
}
